"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("@web3-react/abstract-connector");

function n(t, n, e, r, o, i, a) {
  try {
    var c = t[i](a),
        u = c.value;
  } catch (t) {
    return void e(t);
  }

  c.done ? n(u) : Promise.resolve(u).then(r, o);
}

function e(t) {
  return function () {
    var e = this,
        r = arguments;
    return new Promise(function (o, i) {
      var a = t.apply(e, r);

      function c(t) {
        n(a, o, i, c, u, "next", t);
      }

      function u(t) {
        n(a, o, i, c, u, "throw", t);
      }

      c(void 0);
    });
  };
}

function r() {
  return (r = Object.assign || function (t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function o(t, n) {
  t.prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n;
}

function i(t) {
  return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function a(t, n) {
  return (a = Object.setPrototypeOf || function (t, n) {
    return t.__proto__ = n, t;
  })(t, n);
}

function c() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function u(t, n, e) {
  return (u = c() ? Reflect.construct : function (t, n, e) {
    var r = [null];
    r.push.apply(r, n);
    var o = new (Function.bind.apply(t, r))();
    return e && a(o, e.prototype), o;
  }).apply(null, arguments);
}

function h(t) {
  var n = "function" == typeof Map ? new Map() : void 0;
  return (h = function h(t) {
    if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== n) {
      if (n.has(t)) return n.get(t);
      n.set(t, e);
    }

    function e() {
      return u(t, arguments, i(this).constructor);
    }

    return e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), a(e, t);
  })(t);
}

function s(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

require("tiny-warning");

var f,
    l = (function (t) {
  var n = function (t) {
    var n = Object.prototype,
        e = n.hasOwnProperty,
        r = "function" == typeof Symbol ? Symbol : {},
        o = r.iterator || "@@iterator",
        i = r.asyncIterator || "@@asyncIterator",
        a = r.toStringTag || "@@toStringTag";

    function c(t, n, e) {
      return Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[n];
    }

    try {
      c({}, "");
    } catch (t) {
      c = function c(t, n, e) {
        return t[n] = e;
      };
    }

    function u(t, n, e, r) {
      var o = Object.create((n && n.prototype instanceof f ? n : f).prototype),
          i = new B(r || []);
      return o._invoke = function (t, n, e) {
        var r = "suspendedStart";
        return function (o, i) {
          if ("executing" === r) throw new Error("Generator is already running");

          if ("completed" === r) {
            if ("throw" === o) throw i;
            return {
              value: void 0,
              done: !0
            };
          }

          for (e.method = o, e.arg = i;;) {
            var a = e.delegate;

            if (a) {
              var c = C(a, e);

              if (c) {
                if (c === s) continue;
                return c;
              }
            }

            if ("next" === e.method) e.sent = e._sent = e.arg;else if ("throw" === e.method) {
              if ("suspendedStart" === r) throw r = "completed", e.arg;
              e.dispatchException(e.arg);
            } else "return" === e.method && e.abrupt("return", e.arg);
            r = "executing";
            var u = h(t, n, e);

            if ("normal" === u.type) {
              if (r = e.done ? "completed" : "suspendedYield", u.arg === s) continue;
              return {
                value: u.arg,
                done: e.done
              };
            }

            "throw" === u.type && (r = "completed", e.method = "throw", e.arg = u.arg);
          }
        };
      }(t, e, i), o;
    }

    function h(t, n, e) {
      try {
        return {
          type: "normal",
          arg: t.call(n, e)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = u;
    var s = {};

    function f() {}

    function l() {}

    function d() {}

    var p = {};

    p[o] = function () {
      return this;
    };

    var w = Object.getPrototypeOf,
        v = w && w(w(_([])));
    v && v !== n && e.call(v, o) && (p = v);
    var y = d.prototype = f.prototype = Object.create(p);

    function g(t) {
      ["next", "throw", "return"].forEach(function (n) {
        c(t, n, function (t) {
          return this._invoke(n, t);
        });
      });
    }

    function m(t, n) {
      var r;

      this._invoke = function (o, i) {
        function a() {
          return new n(function (r, a) {
            !function r(o, i, a, c) {
              var u = h(t[o], t, i);

              if ("throw" !== u.type) {
                var s = u.arg,
                    f = s.value;
                return f && "object" == typeof f && e.call(f, "__await") ? n.resolve(f.__await).then(function (t) {
                  r("next", t, a, c);
                }, function (t) {
                  r("throw", t, a, c);
                }) : n.resolve(f).then(function (t) {
                  s.value = t, a(s);
                }, function (t) {
                  return r("throw", t, a, c);
                });
              }

              c(u.arg);
            }(o, i, r, a);
          });
        }

        return r = r ? r.then(a, a) : a();
      };
    }

    function C(t, n) {
      var e = t.iterator[n.method];

      if (void 0 === e) {
        if (n.delegate = null, "throw" === n.method) {
          if (t.iterator.return && (n.method = "return", n.arg = void 0, C(t, n), "throw" === n.method)) return s;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return s;
      }

      var r = h(e, t.iterator, n.arg);
      if ("throw" === r.type) return n.method = "throw", n.arg = r.arg, n.delegate = null, s;
      var o = r.arg;
      return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = void 0), n.delegate = null, s) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, s);
    }

    function b(t) {
      var n = {
        tryLoc: t[0]
      };
      1 in t && (n.catchLoc = t[1]), 2 in t && (n.finallyLoc = t[2], n.afterLoc = t[3]), this.tryEntries.push(n);
    }

    function x(t) {
      var n = t.completion || {};
      n.type = "normal", delete n.arg, t.completion = n;
    }

    function B(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(b, this), this.reset(!0);
    }

    function _(t) {
      if (t) {
        var n = t[o];
        if (n) return n.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var r = -1,
              i = function n() {
            for (; ++r < t.length;) {
              if (e.call(t, r)) return n.value = t[r], n.done = !1, n;
            }

            return n.value = void 0, n.done = !0, n;
          };

          return i.next = i;
        }
      }

      return {
        next: k
      };
    }

    function k() {
      return {
        value: void 0,
        done: !0
      };
    }

    return l.prototype = y.constructor = d, d.constructor = l, l.displayName = c(d, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var n = "function" == typeof t && t.constructor;
      return !!n && (n === l || "GeneratorFunction" === (n.displayName || n.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : (t.__proto__ = d, c(t, a, "GeneratorFunction")), t.prototype = Object.create(y), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, g(m.prototype), m.prototype[i] = function () {
      return this;
    }, t.AsyncIterator = m, t.async = function (n, e, r, o, i) {
      void 0 === i && (i = Promise);
      var a = new m(u(n, e, r, o), i);
      return t.isGeneratorFunction(e) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, g(y), c(y, a, "Generator"), y[o] = function () {
      return this;
    }, y.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var n = [];

      for (var e in t) {
        n.push(e);
      }

      return n.reverse(), function e() {
        for (; n.length;) {
          var r = n.pop();
          if (r in t) return e.value = r, e.done = !1, e;
        }

        return e.done = !0, e;
      };
    }, t.values = _, B.prototype = {
      constructor: B,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !t) for (var n in this) {
          "t" === n.charAt(0) && e.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = void 0);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var n = this;

        function r(e, r) {
          return a.type = "throw", a.arg = t, n.next = e, r && (n.method = "next", n.arg = void 0), !!r;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
              a = i.completion;
          if ("root" === i.tryLoc) return r("end");

          if (i.tryLoc <= this.prev) {
            var c = e.call(i, "catchLoc"),
                u = e.call(i, "finallyLoc");

            if (c && u) {
              if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return r(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return r(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, n) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];

          if (o.tryLoc <= this.prev && e.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === t || "continue" === t) && i.tryLoc <= n && n <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = n, i ? (this.method = "next", this.next = i.finallyLoc, s) : this.complete(a);
      },
      complete: function complete(t, n) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && n && (this.next = n), s;
      },
      finish: function finish(t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var e = this.tryEntries[n];
          if (e.finallyLoc === t) return this.complete(e.completion, e.afterLoc), x(e), s;
        }
      },
      catch: function _catch(t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var e = this.tryEntries[n];

          if (e.tryLoc === t) {
            var r = e.completion;

            if ("throw" === r.type) {
              var o = r.arg;
              x(e);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, n, e) {
        return this.delegate = {
          iterator: _(t),
          resultName: n,
          nextLoc: e
        }, "next" === this.method && (this.arg = void 0), s;
      }
    }, t;
  }(t.exports);

  try {
    regeneratorRuntime = n;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(n);
  }
}(f = {
  exports: {}
}), f.exports);

function d(t) {
  return t.hasOwnProperty("result") ? t.result : t;
}

var p = function (t) {
  function n() {
    var n;
    return (n = t.call(this) || this).name = n.constructor.name, n.message = "No BSC provider was found on window.BinanceChain.", n;
  }

  return o(n, t), n;
}(h(Error)),
    w = function (t) {
  function n() {
    var n;
    return (n = t.call(this) || this).name = n.constructor.name, n.message = "The user rejected the request.", n;
  }

  return o(n, t), n;
}(h(Error));

exports.BscConnector = function (t) {
  function n(n) {
    var e;
    return (e = t.call(this, n) || this).handleNetworkChanged = e.handleNetworkChanged.bind(s(e)), e.handleChainChanged = e.handleChainChanged.bind(s(e)), e.handleAccountsChanged = e.handleAccountsChanged.bind(s(e)), e.handleClose = e.handleClose.bind(s(e)), e;
  }

  o(n, t);
  var i = n.prototype;
  return i.handleChainChanged = function (t) {
    this.emitUpdate({
      chainId: t,
      provider: window.BinanceChain
    });
  }, i.handleAccountsChanged = function (t) {
    0 === t.length ? this.emitDeactivate() : this.emitUpdate({
      account: t[0]
    });
  }, i.handleClose = function (t, n) {
    this.emitDeactivate();
  }, i.handleNetworkChanged = function (t) {
    this.emitUpdate({
      chainId: t,
      provider: window.BinanceChain
    });
  }, i.activate = function () {
    var t = e(l.mark(function t() {
      var n;
      return l.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (window.BinanceChain) {
                t.next = 2;
                break;
              }

              throw new p();

            case 2:
              return window.BinanceChain.on && (window.BinanceChain.on("chainChanged", this.handleChainChanged), window.BinanceChain.on("accountsChanged", this.handleAccountsChanged), window.BinanceChain.on("close", this.handleClose), window.BinanceChain.on("networkChanged", this.handleNetworkChanged)), window.BinanceChain.isMetaMask && (window.BinanceChain.autoRefreshOnNetworkChange = !1), t.prev = 4, t.next = 7, window.BinanceChain.send("eth_requestAccounts").then(function (t) {
                return d(t)[0];
              });

            case 7:
              n = t.sent, t.next = 15;
              break;

            case 10:
              if (t.prev = 10, t.t0 = t.catch(4), 4001 !== t.t0.code) {
                t.next = 14;
                break;
              }

              throw new w();

            case 14:
            case 15:
              if (n) {
                t.next = 19;
                break;
              }

              return t.next = 18, window.BinanceChain.enable().then(function (t) {
                return t && d(t)[0];
              });

            case 18:
              n = t.sent;

            case 19:
              return t.abrupt("return", r({
                provider: window.BinanceChain
              }, n ? {
                account: n
              } : {}));

            case 20:
            case "end":
              return t.stop();
          }
        }
      }, t, this, [[4, 10]]);
    }));
    return function () {
      return t.apply(this, arguments);
    };
  }(), i.getProvider = function () {
    var t = e(l.mark(function t() {
      return l.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", window.BinanceChain);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }));
    return function () {
      return t.apply(this, arguments);
    };
  }(), i.getChainId = function () {
    var t = e(l.mark(function t() {
      var n;
      return l.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (window.BinanceChain) {
                t.next = 2;
                break;
              }

              throw new p();

            case 2:
              return t.prev = 2, t.next = 5, window.BinanceChain.send("eth_chainId").then(d);

            case 5:
              n = t.sent, t.next = 11;
              break;

            case 8:
              t.prev = 8, t.t0 = t.catch(2);

            case 11:
              if (n) {
                t.next = 21;
                break;
              }

              return t.prev = 12, t.next = 15, window.BinanceChain.send("net_version").then(d);

            case 15:
              n = t.sent, t.next = 21;
              break;

            case 18:
              t.prev = 18, t.t1 = t.catch(12);

            case 21:
              if (!n) try {
                n = d(window.BinanceChain.send({
                  method: "net_version"
                }));
              } catch (t) {}
              return n || (n = window.BinanceChain.isDapper ? d(window.BinanceChain.cachedResults.net_version) : window.BinanceChain.chainId || window.BinanceChain.netVersion || window.BinanceChain.networkVersion || window.BinanceChain._chainId), t.abrupt("return", n);

            case 24:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[2, 8], [12, 18]]);
    }));
    return function () {
      return t.apply(this, arguments);
    };
  }(), i.getAccount = function () {
    var t = e(l.mark(function t() {
      var n;
      return l.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (window.BinanceChain) {
                t.next = 2;
                break;
              }

              throw new p();

            case 2:
              return t.prev = 2, t.next = 5, window.BinanceChain.send("eth_accounts").then(function (t) {
                return d(t)[0];
              });

            case 5:
              n = t.sent, t.next = 11;
              break;

            case 8:
              t.prev = 8, t.t0 = t.catch(2);

            case 11:
              if (n) {
                t.next = 21;
                break;
              }

              return t.prev = 12, t.next = 15, window.BinanceChain.enable().then(function (t) {
                return d(t)[0];
              });

            case 15:
              n = t.sent, t.next = 21;
              break;

            case 18:
              t.prev = 18, t.t1 = t.catch(12);

            case 21:
              return n || (n = d(window.BinanceChain.send({
                method: "eth_accounts"
              }))[0]), t.abrupt("return", n);

            case 23:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[2, 8], [12, 18]]);
    }));
    return function () {
      return t.apply(this, arguments);
    };
  }(), i.deactivate = function () {
    window.BinanceChain && window.BinanceChain.removeListener && (window.BinanceChain.removeListener("chainChanged", this.handleChainChanged), window.BinanceChain.removeListener("accountsChanged", this.handleAccountsChanged), window.BinanceChain.removeListener("close", this.handleClose), window.BinanceChain.removeListener("networkChanged", this.handleNetworkChanged));
  }, i.isAuthorized = function () {
    var t = e(l.mark(function t() {
      return l.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (window.BinanceChain) {
                t.next = 2;
                break;
              }

              return t.abrupt("return", !1);

            case 2:
              return t.prev = 2, t.next = 5, window.BinanceChain.send("eth_accounts").then(function (t) {
                return d(t).length > 0;
              });

            case 5:
              return t.abrupt("return", t.sent);

            case 8:
              return t.prev = 8, t.t0 = t.catch(2), t.abrupt("return", !1);

            case 11:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[2, 8]]);
    }));
    return function () {
      return t.apply(this, arguments);
    };
  }(), n;
}(t.AbstractConnector), exports.NoBscProviderError = p, exports.UserRejectedRequestError = w;